module.exports = __webpack_public_path__ + "static/media/logo.79c7ffa8.png";